import { render } from "./AbilityEditor.vue?vue&type=template&id=0d61a7cd&lang=true"
import script from "./AbilityEditor.vue?vue&type=script&lang=js"
export * from "./AbilityEditor.vue?vue&type=script&lang=js"

import "./AbilityEditor.vue?vue&type=style&index=0&id=0d61a7cd&lang=scss"
script.render = render

export default script